
import { ControlElement } from '@jsonforms/core';
import { defineComponent, toRaw } from 'vue';
import { RendererProps, rendererProps, useJsonFormsControl } from '@jsonforms/vue';
import { useClearOnRefresh, useAutoSetOnChange } from '../../util';

const controlRenderer = defineComponent({
  name: 'boolean-control-renderer-v2',
  props: {
    ...rendererProps<ControlElement>(),
  },
  data() {
    return {
      disable: false,
      inputData: false,
    };
  },
  mounted() {
    this.disable = this.control.uischema.options && this.control.uischema.options.editable === false ? true : false;
    this.onChange(this.control.data ? this.control.data : false);
  },
  setup(props: RendererProps<ControlElement>) {
    const input = useJsonFormsControl(props);
    useAutoSetOnChange(input.control, input.handleChange);
    useClearOnRefresh(input.control, input.handleChange);
    return input;
  },
  methods: {
    onChange(event: any) {
      this.handleChange(this.control.path, toRaw(event));
    },
  },
});
export default controlRenderer;
